module.exports = __webpack_public_path__ + "img/not-found.ab265af2.svg";